<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable camelcase -->
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import { id as idLocale } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import PaginationCustom from '@/components/table/Pagination.vue'
import ProyekDetail from '@/components/oss/ProyekDetail.vue'
import IzinLama from '@/components/oss/IzinLama.vue'
import appData from '@/data'
import kodeDaerah from '@/data/modules/kodeDaerah'
import 'vue-pdf-app/dist/icons/main.css'

export default {
   name: 'OssBidangUsaha',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      ProyekDetail,
      IzinLama,
      SweetModal,
      VuePdfApp,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         idProyek: '',
         loading: true,
         filterDateLang: idLocale,
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               tanggal_awal: null,
               tanggal_akhir: null,
               kd_skala_usaha: null,
               jenis_perusahaan: null,
               status_penanaman_modal: null,
               perusahaan_daerah_id: null,
               daerah_mode: 'kecamatan',
               sektor: null,
               kd_resiko: null,
               modal_di_atas: null,
               modal_di_bawah: null,
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [
            {
               label: 'Nama / NIB',
               field: 'nib',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Bidang Usaha / Alamat',
               field: 'kbli',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Nama & Data Usaha',
               field: 'data_usaha',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Kategori',
               field: 'kd_resiko',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Status',
               field: 'status',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center',
            },
         ],
      }
   },

   computed: {
      ...mapState({
         myData: state => state.OssBidangUsaha.items,
         myCount: state => state.OssBidangUsaha.countAll,
      }),
      jenisPerusahaan() {
         const data = appData.jenisPerusahaan
         return status => (data[status] ? data[status] : status)
      },
      skalaUsaha() {
         const data = appData.skalaUsaha
         return status => (data[status] ? data[status] : status)
      },
      statusPM() {
         const data = appData.statusPm
         return status => (data[status] ? data[status] : status)
      },
      statusResiko() {
         const data = appData.statusResiko
         return status => (data[status] ? data[status] : '-')
      },
      sektorCode() {
         const data = appData.sektor
         return status => (data[status] ? data[status] : status)
      },
      statusProyek() {
         const data = appData.statusProyek
         return status => (data[status] ? data[status] : status)
      },
      optionsSkalaUsaha() {
         return Object.entries(appData.skalaUsaha).map(([value, text]) => ({ value, text }))
      },
      optionsJenisPerusahaan() {
         return Object.entries(appData.jenisPerusahaan).map(([value, text]) => ({ value, text }))
      },
      optionsStatusPM() {
         return Object.entries(appData.statusPm).map(([value, text]) => ({ value, text }))
      },
      optionsDaerah() {
         return kodeDaerah.map(item => ({
            value: item.kode,
            text: `${item.kode} - ${item.kecamatan} - ${item.kelurahan}`,
         }))
      },
      optionsSektor() {
         return Object.entries(appData.sektor).map(([value, text]) => ({ value, text }))
      },
      optionsStatusResiko() {
         return Object.entries(appData.statusResiko).map(([value, text]) => ({ value, text }))
      },
      modalOptions() {
         return [1000000, 10000000, 50000000, 100000000]
      },
      modalRangeError() {
         const atas = this.serverParams.filter.modal_di_atas
         const bawah = this.serverParams.filter.modal_di_bawah
         const min = atas !== '' && atas != null ? Number(atas) : null
         const max = bawah !== '' && bawah != null ? Number(bawah) : null
         if (min != null && max != null && min > max) {
            return 'Modal di atas tidak boleh lebih besar dari modal di bawah'
         }
         return ''
      },
      modalRangeState() {
         return this.modalRangeError ? false : null
      },
      momentDateTimeUtc() {
         return datetime => this.$moment(datetime).utc().format('HH:mm | DD-MM-YYYY')
      },
      convertBr2List() {
         return data => {
            // Guard: pastikan data valid
            if (!data || typeof data !== 'object') {
               return '<ul></ul>'
            }

            // Escape HTML untuk mencegah XSS (hasil dirender via v-html)
            const escapeHtml = value => String(value ?? '')
               .replace(/&/g, '&amp;')
               .replace(/</g, '&lt;')
               .replace(/>/g, '&gt;')
               .replace(/"/g, '&quot;')
               .replace(/'/g, '&#039;')

            // Guard: pastikan keterangan_izin ada & berupa string
            const keterangan = typeof data.keterangan_izin === 'string' ? data.keterangan_izin : ''

            const cleanedText = keterangan.replace(/<br\s*\/?>/gi, '\n')

            const itemsArray = cleanedText.split('\n')

            let ulContent = ''

            itemsArray.forEach(itemText => {
               const trimmedText = itemText.trim()

               if (trimmedText) {
                  ulContent += `<li>${escapeHtml(trimmedText)}</li>`
               }
            })

            ulContent += `<li>Status Kode : ${escapeHtml(data.status)}</li>`

            const finalHtmlString = `<ul>${ulContent}</ul>`

            return finalHtmlString
         }
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'OssBidangUsaha/getData',
         cetakNib: 'OssNib/cetakNib',
         cetakIzinLama: 'OssBidangUsaha/cetakIzinLama',
         cetakBidangUsaha: 'OssBidangUsaha/cetakBidangUsaha',
      }),
      ...mapMutations({
         setIdProyek: 'OssBidangUsaha/SET_ID_PROYEK',
      }),
      onDetailProyek(idProyek) {
         this.setIdProyek(idProyek)
         this.$bvModal.show('modal-detail')
      },
      onListIzinLama(idProyek) {
         this.setIdProyek(idProyek)
         this.$bvModal.show('modal-izin-lama')
      },
      onCetakNib(nib) {
         this.loadingPdf = true
         this.cetakNib(nib).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetakIzinLama(id) {
         this.loadingPdf = true
         this.cetakIzinLama(id).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         if (this.modalRangeError) {
            this.$toast.error(this.modalRangeError)
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.serverParams.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.serverParams.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.serverParams.filter.kd_skala_usaha !== null) {
            params.kd_skala_usaha = this.serverParams.filter.kd_skala_usaha
         }
         if (this.serverParams.filter.jenis_perusahaan !== null) {
            params.jenis_perusahaan = this.serverParams.filter.jenis_perusahaan
         }
         if (this.serverParams.filter.status_penanaman_modal !== null) {
            params.status_penanaman_modal = this.serverParams.filter.status_penanaman_modal
         }
         if (this.serverParams.filter.perusahaan_daerah_id !== null) {
            params.perusahaan_daerah_id = this.serverParams.filter.perusahaan_daerah_id
            params.daerah_mode = this.serverParams.filter.daerah_mode
         }
         if (this.serverParams.filter.sektor !== null) {
            params.sektor = this.serverParams.filter.sektor
         }
         if (this.serverParams.filter.kd_resiko !== null) {
            params.kd_resiko = this.serverParams.filter.kd_resiko
         }
         if (this.serverParams.filter.modal_di_atas !== null && this.serverParams.filter.modal_di_atas !== '') {
            params.modal_di_atas = this.serverParams.filter.modal_di_atas
         }
         if (this.serverParams.filter.modal_di_bawah !== null && this.serverParams.filter.modal_di_bawah !== '') {
            params.modal_di_bawah = this.serverParams.filter.modal_di_bawah
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakBidangUsaha(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },

      // VUE GOOD TABLE
      async loadItems() {
         this.loading = true
         await this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onFilter() {
         if (this.modalRangeError) {
            this.$toast.error(this.modalRangeError)
            return
         }
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },
      onModalChange() {
         if (this.modalRangeError) {
            this.$toast.error(this.modalRangeError)
            return
         }
         this.onFilter()
      },
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.serverParams.filter.tanggal_akhir = new Date()
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = null
         this.serverParams.filter.tanggal_akhir = null
         this.serverParams.filter.kd_skala_usaha = null
         this.serverParams.filter.jenis_perusahaan = null
         this.serverParams.filter.status_penanaman_modal = null
         this.serverParams.filter.perusahaan_daerah_id = null
         this.serverParams.filter.daerah_mode = 'kecamatan'
         this.serverParams.filter.sektor = null
         this.serverParams.filter.kd_resiko = null
         this.serverParams.filter.modal_di_atas = null
         this.serverParams.filter.modal_di_bawah = null
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Bidang Usaha">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button v-b-toggle.collapse-filter variant="outline-secondary" size="sm">
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onFilter()">
                           Filter
                        </b-dropdown-item>
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col cols="12">
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="3">
                           <b-form-group label="Tanggal Awal" label-for="tanggal-awal">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_awal"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Tanggal Akhir" label-for="tanggal-akhir">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_akhir"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Jenis Perusahaan" label-for="jenis-perusahaan">
                              <v-select
                                 id="jenis-perusahaan"
                                 v-model="serverParams.filter.jenis_perusahaan"
                                 :options="optionsJenisPerusahaan"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Status Penanaman Modal" label-for="status-pm">
                              <v-select
                                 id="status-pm"
                                 v-model="serverParams.filter.status_penanaman_modal"
                                 :options="optionsStatusPM"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Status PM..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Skala Usaha" label-for="skala-usaha">
                              <v-select
                                 id="skala-usaha"
                                 v-model="serverParams.filter.kd_skala_usaha"
                                 :options="optionsSkalaUsaha"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Skala..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Risiko" label-for="risiko">
                              <v-select
                                 id="risiko"
                                 v-model="serverParams.filter.kd_resiko"
                                 :options="optionsStatusResiko"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Risiko..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group
                              label="Modal di Atas"
                              label-for="modal-atas"
                              :invalid-feedback="modalRangeError"
                              :state="modalRangeState"
                           >
                              <b-input-group prepend="Rp.">
                                 <b-form-input
                                    id="modal-atas"
                                    v-model.number="serverParams.filter.modal_di_atas"
                                    type="number"
                                    list="modal-atas-list"
                                    placeholder="Contoh: 10000000"
                                    :state="modalRangeState"
                                    @change="onModalChange"
                                 />
                                 <b-form-datalist id="modal-atas-list" :options="modalOptions" />
                              </b-input-group>
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group
                              label="Modal di Bawah"
                              label-for="modal-bawah"
                              :invalid-feedback="modalRangeError"
                              :state="modalRangeState"
                           >
                              <b-input-group prepend="Rp.">
                                 <b-form-input
                                    id="modal-bawah"
                                    v-model.number="serverParams.filter.modal_di_bawah"
                                    type="number"
                                    list="modal-bawah-list"
                                    placeholder="Contoh: 1000000"
                                    :state="modalRangeState"
                                    @change="onModalChange"
                                 />
                                 <b-form-datalist id="modal-bawah-list" :options="modalOptions" />
                              </b-input-group>
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Daerah" label-for="daerah">
                              <b-form-radio-group
                                 id="daerah-mode"
                                 v-model="serverParams.filter.daerah_mode"
                                 :options="[{ text: 'Kecamatan', value: 'kecamatan' }, { text: 'Kelurahan/Desa', value: 'kelurahan' }]"
                                 class="mb-1"
                                 @change="serverParams.filter.perusahaan_daerah_id = null; onFilter()"
                              />
                              <v-select
                                 id="daerah"
                                 v-model="serverParams.filter.perusahaan_daerah_id"
                                 :options="optionsDaerah"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Daerah..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Sektor" label-for="sektor">
                              <v-select
                                 id="sektor"
                                 v-model="serverParams.filter.sektor"
                                 :options="optionsSektor"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Sektor..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>

                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'nib'">
                  <b>{{ (props.row.nama_perusahaan) }}</b>
                  <br>
                  <hr>
                  <b class="text-primary">{{ (props.row.nib) }}</b>
                  <hr>
                  <small>{{ jenisPerusahaan(props.row.jenis_perusahaan) }}</small>
                  <hr>
                  <small>{{ statusPM(props.row.status_penanaman_modal) }}</small>
                  <hr>
                  <small>{{ statusPM(props.row.id_proyek) }}</small>
               </span>

               <span v-if="props.column.field == 'kbli'">
                  <b>KBLI : {{ props.row.kbli }}</b>
                  <hr>
                  <small>{{ props.row.kbli_nama || '-' }}</small>
                  <hr>
                  <small>
                     Alamat :
                     <b>{{ props.row.alamat_usaha }}</b>
                  </small>
                  <hr>
                  <small>
                     Desa/kel:
                     <b>{{ props.row.kelurahan }}</b>
                     <br>Kec:
                     <b>{{ props.row.kecamatan }}</b>
                  </small>
               </span>

               <span v-if="props.column.field == 'data_usaha'">
                  <table class="borderless">
                     <tr>
                        <td>
                           <small>Nama</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <small>
                              <b>{{ props.row.nama_proyek }}</b>
                           </small>
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <small>Modal</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <b class="text-danger">
                              <small>{{ (props.row.jumlah_investasi) | formatNumber }}</small>
                           </b>
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <small>TKI</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <small>{{ (props.row.jumlah_tenaga_kerja) }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <small>TKA</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <small>{{ (props.row.jumlah_tenaga_kerja_asing) }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <small>Migrasi</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <small>{{ (props.row.flag_migrasi) }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <small>Date</small>
                        </td>
                        <td>
                           <small>&nbsp;:&nbsp;</small>
                        </td>
                        <td>
                           <small>{{ momentDateTimeUtc(props.row.latest_date) }}</small>
                        </td>
                     </tr>
                  </table>
               </span>

               <span v-if="props.column.field == 'kd_resiko'">
                  <small>
                     <table class="borderless">
                        <tr>
                           <td>Sektor</td>
                           <td>&nbsp;:&nbsp;</td>
                           <td>
                              <b class="text-danger">{{ sektorCode(props.row.sektor) }}</b>
                           </td>
                        </tr>
                        <tr>
                           <td>Resiko</td>
                           <td>&nbsp;:&nbsp;</td>
                           <td>
                              <b class="text-danger">{{ statusResiko(props.row.kd_resiko) }}</b>
                           </td>
                        </tr>
                        <tr>
                           <td>Skala</td>
                           <td>&nbsp;:&nbsp;</td>
                           <td>{{ skalaUsaha(props.row.kd_skala_usaha) }}</td>
                        </tr>
                     </table>
                  </small>
               </span>

               <span v-if="props.column.field == 'status'">
                  <small><div v-html="convertBr2List(props.row)" /></small>

                  <!-- <small>Status : {{ statusProyek(props.row.status) }}</small> -->
               </span>

               <span v-if="props.column.field == 'action'">
                  <center>
                     <b-dropdown
                        variant="relief-secondary"
                        right
                        text="Menu"
                        size="sm"
                        block
                     >
                        <b-dropdown-item @click="onDetailProyek(props.row.id_proyek)">
                           Detail
                        </b-dropdown-item>
                        <b-dropdown-item @click="onListIzinLama(props.row.id_proyek)">
                           Izin Lama
                        </b-dropdown-item>
                        <b-dropdown-item @click="onCetakNib(props.row.nib)">
                           Cetak NIB
                        </b-dropdown-item>
                     </b-dropdown>

                     <!-- <b-button
                        v-b-tooltip.hover.top="'Cetak NIB'"
                        size="sm"
                        block
                        variant="primary"
                        @click="onCetakNib(props.row.nib)"
                     >
                        <feather-icon icon="FileTextIcon" class="mr-50" />
                        <small>NIB</small>
                     </b-button> -->
                  </center>
               </span>

               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-detail"
         scrollable
         size="xl"
         hide-footer
         title="Bidang Usaha Detail"
      >
         <ProyekDetail ref="proyekDetail" />
      </b-modal>

      <b-modal
         id="modal-izin-lama"
         scrollable
         size="lg"
         hide-footer
         title="Izin Lama"
      >
         <IzinLama ref="izinLama" @update:pdf="onCetakIzinLama" />
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless > tr > td {
   border: none;
   padding: 0em;
}
table > tbody > tr > td > span > hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
